'use strict';

var util = require('../../util/property-util');

module.exports = /*@ngInject*/ ["$filter", function ($filter) {
    return function (millis) {
        return parseTimestamp($filter,millis,'MMM D, YYYY H:mm:ss a');
    };

    function parseTimestamp($filter, millis, format){
        if (!util.isDefined(millis)) {
            return $filter('translate')('UNKNOWN');
        } else {
            return $filter('tzdate')(millis, format);
        }
    }
}];

